import { ButtonHTMLAttributes, forwardRef } from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'primary', children, ...props }, ref) => {
    const baseStyles =
      'select-none touch-action-manipulation font-bold text-lg transition-all duration-150 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed rounded-2xl px-8 py-4 min-w-[180px] min-h-[56px] flex items-center justify-center gap-2';
    const variants = {
      primary:
        'bg-[#FFD93D] text-[#1a1a1a] shadow-[4px_4px_0_0_#B8860B] hover:shadow-[6px_6px_0_0_#B8860B] hover:translate-x-[-1px] hover:translate-y-[-1px]',
      secondary:
        'bg-[#F5E6D3] text-[#1a1a1a] shadow-[3px_3px_0_0_#D4C4B0] hover:shadow-[5px_5px_0_0_#D4C4B0] hover:translate-x-[-1px] hover:translate-y-[-1px]',
    };
    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${className}`}
        style={{
          WebkitTapHighlightColor: 'transparent',
          touchAction: 'manipulation',
        }}
        {...props}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = 'Button';